import { render } from "./DialogEntrancePlantCreateSetupBuilding.vue?vue&type=template&id=af16089e&ts=true"
import script from "./DialogEntrancePlantCreateSetupBuilding.ts?vue&type=script&lang=ts"
export * from "./DialogEntrancePlantCreateSetupBuilding.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__